import React, { useState, useEffect, useRef } from "react";
import "new_components/AboutUs/AboutUs.scss";
import Header from "new_components/Header/Header";
import Footer from "new_components/Footer/Footer";
import ProgressCircle from "new_components/ScrollProgress/ScrollProgress";
import axios from "axios";
import apiUrls, { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import ScrollToTopDefault from "components/Layouts/LayoutPrimary/ScrollToTopDefault";
// import { Image_Base_URL } from "new_components/BaseApi/BaseApi.js";
import PreLoad from "new_components/PreLoad/PreLoad";
import HomeBottomBanner from "new_components/Home/HomeBottomBanner";
const AboutUs = () => {
  return (
    <>
      <ScrollToTopDefault />
      <Header />
      <ProgressCircle />
      <Body />
      <Footer />
    </>
  );
};

const Body = () => {
  return (
    <>
      <div>
        <AboutUsBanner />
        <GrowthSection />
        <ValuesSection />
        <TeamSection />
        <Partners />
        {/* <MissionSection /> */}
        <HomeBottomBanner />
      </div>
    </>
  );
};

const AboutUsBanner = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.aboutBanners);
        const firstItem = response.data?.data?.[0];

        if (firstItem && firstItem.is_active) {
          setData({
            title: firstItem.title,
            image: firstItem.image,
            altText: firstItem.alt_text,
          });
        } else {
          setError("No active banner data available.");
        }
      } catch (err) {
        setError("Failed to fetch the About Us data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div>
        <PreLoad />
      </div>
    );
  }

  if (error) {
    return <div className="error-message text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section">
      <div className="container">
        <div
          className="row align-items-center justify-content-center wow fadeInUp mx-md-5 aboutusbanner"
          data-wow-delay=".2s"
          style={{
            backgroundImage: `url(${Image_Base_URL}${data.image})`, // Dynamically set background image
          }}
        >
          <div className="col-12 text-center">
            <h3 className="title text-white ">{data.title || "About Us"}</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

const GrowthSection = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.aboutContentGrowth);
        setData(response.data.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch growth data. Please try again later.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="text-center">
        <PreLoad />
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <section className="flat-section pt-0">
      <div className="container">
        <div className="box-title text-center wow fadeInUp">
          <h3 className="mt-4 title">{data.title}</h3>
        </div>
        <div className="row align-items-center justify-content-center wow fadeInUp" data-wow-delay=".2s">
          <div className="col-12 col-md-8 mb-2">
            <p className="body-2 mb-3">{data.content}</p>
          </div>
          <div className="col-12 col-md-4 text-center">
            <img src={Image_Base_URL + data.image} alt={data.alt_text} className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
};
const ValuesSection = () => {
  const [valuesData, setValuesData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrls.aboutContentValues);
        setValuesData(response.data.data);
      } catch (err) {
        setError("Failed to fetch values data. Please try again later.");
      }
    };

    fetchData();
  }, []);

  return (
    <section className="flat-section pt-0 flat-banner wow fadeInUpSmall" data-wow-delay=".2s" data-wow-duration="2000ms">
      {error ? (
        <div className="error-message text-danger">{error}</div>
      ) : valuesData ? (
        <div className="container">
          <div className="wrap-banner bg-primary-new">
            <div className="box-left" key={valuesData.id}>
              <div className="box-title">
                <h3 className="mt-4 mb-3 fw-8">{valuesData.title}</h3>
                <div className="ourvaluesdata ourvaluesdatapoint ourvaluesdatadesc note body-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: valuesData.content || "Content not available.",
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="box-right">
              {valuesData.image ? (
                <img src={Image_Base_URL + valuesData.image} alt={valuesData.alt_text || "Image"} />
              ) : (
                <div className="placeholder">Loading image...</div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </section>
  );
};

const TeamSection = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTeamData = async () => {
      try {
        const response = await axios.get(apiUrls.team); // Replace with your API endpoint
        if (response.data?.status === "success") {
          setTeamMembers(response.data.data);
        } else {
          setError("Failed to fetch team members. Please try again later.");
        }
      } catch (err) {
        setError("Failed to fetch team members. Please try again later.");
      }
    };

    fetchTeamData();
  }, []);

  return (
    <section className="flat-section flat-agents">
      <div className="container">
        <div className="box-title text-center wow fadeInUp mb-3">
          <div className="text-subtitle text-primary fw-bold">Strategists. Builders. And most importantly — investors in every project.</div>
          <div className=" text-primary fw-bold">We never ask you to invest in an opportunity we wouldn’t put our own money into.</div>
          <h3 className="title mt-4">MEET THE TEAM</h3>
        </div>
        <div className="body-2 mb-5">
          Behind Lucky Duck Group is a team of industry experts with deep experience in real estate investment, development, and management.
          We are residents of Southwest Florida deeply committed to the growth of the region. Between us, we bring strong financial insight,
          market intelligence, and uncompromising focus to the redevelopment effort of the SW Florida region.
        </div>
        {error ? (
          <div className="error-message text-center text-danger">{error}</div>
        ) : (
          <div className="tf-grid-layout xs-col-2 sm-col-4">
            {teamMembers.map((member, index) => (
              <div key={member.id} className="box-agent hover-img wow fadeIn" data-wow-delay={`${0.2 + index * 0.1}s`}>
                <div className="box-img img-style">
                  <img
                    className="lazyload"
                    data-src={Image_Base_URL + member.image || "/placeholder-image.jpg"} // Default image if none provided
                    src={Image_Base_URL + member.image || "/placeholder-image.jpg"}
                    alt={member.name}
                  />
                </div>
                <div className="content">
                  <div className="info">
                    <h6>{member.name}</h6>
                    <p className="text-variant-1">{member.designation}</p>
                  </div>
                  <div className="box-icon">
                    <span className="icon fa-solid fa-info" data-bs-toggle="modal" data-bs-target={`#teamModal${member.id}`}></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {teamMembers.map((member) => (
        <TeamModal
          key={member.id}
          id={`teamModal${member.id}`}
          name={member.name}
          imageSrc={Image_Base_URL + member.image || "/placeholder-image.jpg"}
          description={member.bio || "No description available."}
        />
      ))}
    </section>
  );
};
const TeamModal = ({ id, name, imageSrc, description }) => {
  return (
    <div className="modal fade" id={id} tabIndex="-1" aria-labelledby={`${id}Label`} aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content px-1 py-1">
          <div className="modal-header">
            <h5 className="modal-title">{name}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="row align-items-center">
              <div className="col-lg-4 col-12 d-flex justify-content-center mb-3">
                <div className="aboutuspageteammember">
                  <img className="aboutuspageteammember" src={imageSrc} alt={name} />
                </div>
              </div>
              <div className="col-lg-8 col-12">
                <div className="aboutuspageteammemberdesc">{description}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Partners = () => {
  const [teampartners, setTeampartners] = useState([]);
  const [error, setError] = useState(null);
  const partnersScrollRef = useRef(null);

  useEffect(() => {
    const fetchpartnersData = async () => {
      try {
        const output = await axios.get(apiUrls.partners); // Replace with your API endpoint
        //  console.log("API response for partners:", output.data); // Debugging log
        if (output.data?.status === "success") {
          // console.log("partners", output.data);
          setTeampartners(output.data.data || []);
        } else {
          setError("Failed to fetch advisory partners. Please try again later.");
        }
      } catch (err) {
        setError("Failed to fetch advisory partners. Please try again later.");
      }
    };

    fetchpartnersData();
  }, []);

  const shouldShowScrollButtons = teampartners.length > 4;

  const handlePartnersScroll = (direction) => {
    if (!partnersScrollRef.current) return;

    const scrollAmount = partnersScrollRef.current.clientWidth * 0.8;
    partnersScrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  const partnerCards = teampartners.map((partner, index) => {
    const card = (
      <div
        className={`box-agent hover-img wow fadeIn ${shouldShowScrollButtons ? "partners-card" : ""}`}
        data-wow-delay={`${0.2 + index * 0.1}s`}
        style={!shouldShowScrollButtons ? { width: "100%" } : {}}
      >
        <div className="box-img img-style">
          <img
            className="lazyload"
            data-src={Image_Base_URL + partner.image || "/placeholder-image.jpg"}
            src={Image_Base_URL + partner.image || "/placeholder-image.jpg"}
            alt={partner.name}
          />
        </div>
        <div className="content justify-content-center">
          <div className="info text-center">
            <h6>{partner.name}</h6>
            <p className="text-variant-1">{partner.designation}</p>
          </div>
        </div>
      </div>
    );

    return shouldShowScrollButtons ? (
      <React.Fragment key={partner.id}>{card}</React.Fragment>
    ) : (
      <div key={partner.id} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 d-flex justify-content-center">
        {card}
      </div>
    );
  });

  return (
    <section className="flat-section flat-agents bg-primary-new">
      <div className="container">
        <div className="box-title text-center wow fadeInUp mb-3">
          <h3 className="title mb-5">ADVISORY PARTNERS</h3>
        </div>
        {error ? (
          <div className="error-message text-center text-danger">{error}</div>
        ) : shouldShowScrollButtons ? (
          <div className="partners-carousel-wrapper">
            <button
              type="button"
              className="partners-scroll-btn partners-scroll-btn-left bg-white"
              onClick={() => handlePartnersScroll("left")}
              aria-label="Scroll partners left"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>

            <div className="partners-carousel" ref={partnersScrollRef}>
              {partnerCards}
            </div>

            <button
              type="button"
              className="partners-scroll-btn partners-scroll-btn-right bg-white"
              onClick={() => handlePartnersScroll("right")}
              aria-label="Scroll partners right"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>
        ) : (
          <div className="row justify-content-center">{partnerCards}</div>
        )}
      </div>
      
    </section>
  );
};

// const MissionSection = () => {
//   const [missionData, setMissionData] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchMissionData = async () => {
//       try {
//         const response = await axios.get(apiUrls.aboutContentMission); // Replace with your API endpoint
//         setMissionData(response.data.data);
//       } catch (err) {
//         setError("Failed to fetch mission data. Please try again later.");
//       }
//     };

//     fetchMissionData();
//   }, []);

//   if (error) {
//     return (
//       <section className="flat-section">
//         <div className="container">
//           <div className="row align-items-center justify-content-center">
//             <div className="col-12 text-center">
//               <p className="text-danger">{error}</p>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   if (!missionData) {
//     return (
//       <section className="flat-section">
//         <div className="container">
//           <div className="row align-items-center justify-content-center">
//             <div className="col-12 text-center">
//               <p className="text-white">Loading...</p>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="flat-section">
//       <div className="container">
//         <div
//           className="row align-items-center justify-content-center wow fadeInUp aboutusfooterbanner"
//           style={{
//             backgroundImage: `url(${Image_Base_URL}${missionData.image})`,
//           }}
//           data-wow-delay=".2s"
//         >
//           <div className="col-12 text-center">
//             <h3 className="title text-white">{missionData.title}</h3>
//             <div
//               className="note body-2 text-white pt-2"
//               dangerouslySetInnerHTML={{
//                 __html: missionData.content || "Description not available",
//               }}
//             ></div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

export default AboutUs;
